import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Backdrop,
  Button,
  CircularProgress,
  Icon,
  IconButton,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Stack } from "@mui/system";
import Checkbox from "@mui/material/Checkbox";
import { useEffect, useState } from "react";
import { Colors } from "../../utils/constants";
import useDebounce from "../../hooks/useDebounce";
import { onSearch as search } from "../../screens/Search/onSearch";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { queryConstructor } from "../../api/formQuery";
import {
  basicSearch,
  basicSearchQuery,
} from "../../api/Search/BasicSearch.api";
import { usagelogApi, usageReport } from "../../api/usageReportApi";
import ClearIcon from "@mui/icons-material/Clear";
import { getNCGDetails } from "./VTB.API";

interface Proptype {
  isOpen: boolean;
  handleClose: () => void;
  modalName: string;
  getFilterdValues?: (e: string[]) => void;
  filterData?: any;
  applyFilter?: (e: string[]) => void;
  placeholderName?: string;
  appliedFilterValues?: string[];
  facetKey?: string;
  filterloader?: boolean;
}

const VTBModal = (props: Proptype) => {
  const {
    isOpen,
    handleClose,
    modalName,
    getFilterdValues,
    filterData,
    applyFilter,
    placeholderName,
    appliedFilterValues,
    facetKey,
    filterloader,
  } = props;
  const dispatch = useAppDispatch();
  const [filteredValues, setFilteredvalues] = useState<string[]>(
    Array.isArray(appliedFilterValues) ? appliedFilterValues : [],
  );
  const [toggleValue, setToggleValue] = useState("relevance");
  const [facetData, setFacetData] = useState(filterData);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedValue = useDebounce(searchTerm);

  const profileData = useAppSelector((state: any) => state.login);

  const profileData1 = useAppSelector(
    (state: any) => state.customer.customerDetails,
  );

  const searchReducer = useAppSelector((state) => state.searchReducer);
  const is_ONOSCustomer = useAppSelector(
    (state: any) => state.customer.customerDetails?.is_enable_onos,
  );
  const filterReducer = useAppSelector(
    (state: any) => state.filterReducer?.collectionValue,
  );

  const filterReducerData = useAppSelector((state: any) => state.filterReducer);
  const filterKeys = Object.keys(filterReducerData);
  const isAIMode = useAppSelector((state) => state.aiMode.isAIMode);

  const logBasicSearchUsageData = (usageActionID: any) => {
    const userId = sessionStorage.getItem("user_id");
    const informaticscustomer_Id = sessionStorage.getItem(
      "informaticscustomer_id",
    );
    const user_ipv4_address =
      sessionStorage.getItem("user_ipv4_address") || null;
    const userMasterId = profileData.user_id
      ? profileData.user_id
      : userId
        ? userId
        : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : informaticscustomer_Id
        ? informaticscustomer_Id
        : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    const isONOS =
      is_ONOSCustomer && filterReducer === "ONOSCollections" ? 1 : 0;
    const isAISearch = isAIMode ? true : false;

    usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      null,
      null,
      null,
      null,
      null,
      null,
      // profileData.ip_v4,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null,
      isONOS,
      null,
      isAISearch,
    );
  };

  useEffect(() => {
    if (debouncedValue) {
      handleSearch();
    } else {
      setFacetData(filterData);
    }
  }, [debouncedValue]);

  useEffect(() => {
    const fetchData = async () => {
      let data: any[] = [];

      if (debouncedValue) {
        data = await handleSearch();
      } else {
        data = Array.isArray(filterData) ? filterData : [];
      }

      if (toggleValue === "alphabetical" && Array.isArray(data)) {
        data = sortAlphabetically(data);
      }

      setFacetData(data);
    };

    fetchData();
  }, [debouncedValue, toggleValue]);

  useEffect(() => {
    setValues();
    setToggleValue("relevance");
  }, [isOpen]);

  function setValues() {
    if (Array.isArray(appliedFilterValues))
      setFilteredvalues(appliedFilterValues);

    setFacetData(filterData);
  }

  const selectedValues = (data: string) => {
    if (filteredValues.length === 0) {
      setFilteredvalues([data]);
      // getFilterdValues && getFilterdValues([data]);
    } else if (filteredValues.includes(data)) {
      setFilteredvalues(() => filteredValues.filter((e) => e !== data));
      // getFilterdValues &&
      //   getFilterdValues(filteredValues.filter((e) => e !== data));
    } else {
      setFilteredvalues((prev) => [...prev, data]);
      // getFilterdValues && getFilterdValues([...filteredValues, data]);
    }
  };

  const handleSubmit = () => {
    if (
      !filteredValues.length &&
      appliedFilterValues &&
      appliedFilterValues?.length <= 0
    )
      return;
    if (modalName === "Filter Author Country") {
      //   logBasicSearchUsageData(60);
    } else if (modalName === "Filter Country of Publishing") {
      //   logBasicSearchUsageData(51);
    } else if (modalName === "Journal") {
      //   logBasicSearchUsageData(59);
    } else if (modalName == "Subject") {
      //   logBasicSearchUsageData(56);
    }
    getFilterdValues && getFilterdValues(filteredValues);
    applyFilter && applyFilter(filteredValues);
    setFilteredvalues([]);
    handleClose();
  };

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    value: string,
  ) => {
    setToggleValue(value);
    if (value === "alphabetical") {
      handleSort();
    } else {
      setFacetData(filterData);
    }
  };

  function handleCancel() {
    setFilteredvalues([]);
    handleClose();
  }

  function clearAll() {
    // getFilterdValues && getFilterdValues([]);
    setFilteredvalues([]);
  }

  function handleSort() {
    let sortedData = [...facetData].sort((a: any, b: any) => {
      let valA = a.val.toUpperCase().replaceAll(/[\s,]/g, "");
      let valB = b.val.toUpperCase().replaceAll(/[\s,]/g, "");

      if (valA > valB) {
        return 1;
      }
      if (valA < valB) {
        return -1;
      }
      return 0;
    });
    setFacetData(sortedData);
  }

  function sortAlphabetically(data: any[]) {
    return [...data].sort((a: any, b: any) => {
      const valA = a.val?.toString().toUpperCase().replace(/[\s,]/g, "") || "";
      const valB = b.val?.toString().toUpperCase().replace(/[\s,]/g, "") || "";
      return valA.localeCompare(valB);
    });
  }

  // Handle search
  async function handleSearch() {
    if (typeof facetKey !== "string") return;
    try {
      //   let json_facet = {
      //     [facetKey]: {
      //       type: "terms",
      //       field: facetKey,
      //       limit: 100,
      //       sort: "index asc",
      //       prefix: searchTerm,
      //     },
      //   };
      //   let query = await queryConstructor({
      //     json_facet: JSON.stringify(json_facet),
      //   });

      let facetConfig: any = {
        type: "terms",
        field: facetKey,
        limit: 100,
        sort: "index asc",
      };

      // Special handling for yearfrom
      if (facetKey === "yearfrom") {
        facetConfig.domain = {
          filter: `yearfrom:[${searchTerm} TO ${searchTerm}]`,
        };
      } else {
        // Normal facet search
        facetConfig.prefix = searchTerm;
      }

      const json_facet = {
        [facetKey]: facetConfig,
      };

      const query = {
        json_facet: JSON.stringify(json_facet),
      };

      const response = await getNCGDetails(query);
      let data: any =
        response?.data?.data?.jsonfacets?.[facetKey]?.buckets ?? [];
      setFacetData(data);
      return data;
    } catch (e) {
      console.log(e);
    }
  }

  function popupTitle() {
    return (
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          //width: { xs: "100%" },
          // width: "100%",
        }}
      >
        <div>
          <Typography variant="h6" fontWeight={"600"} fontFamily="Lora">
            {modalName}
          </Typography>
        </div>
        <div>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
    );
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth={false}
      sx={{
        width: { xs: "110vw", sm: "90%", md: "90%" },
        margin: "auto",
        left: { xs: "-5%", sm: "none" },
        right: { xs: "-5%", sm: "none" },
      }}
    >
      {popupTitle()}
      <DialogContent
        sx={{
          width: { xs: "100%", sm: "100%", md: 906 },
          padding: { xs: "15px 10px", sm: "20px 24px" },
        }}
      >
        {/* Search Bar */}
        {Array.isArray(facetData) && facetData.length > 10 && (
          <TextField
            size="small"
            fullWidth
            placeholder={`Search by ${placeholderName}`}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        )}

        <Stack
          direction={"row"}
          alignItems="center"
          sx={{ gap: 2, marginBlock: { xs: 1, sm: 3 } }}
        >
          <Stack direction={"row"} alignItems="center">
            <ToggleButtonGroup
              onChange={handleChange}
              color="primary"
              exclusive
              aria-label="Platform"
              size="small"
            >
              <ToggleButton
                sx={[
                  toggleValue === "relevance"
                    ? styles.checkedStyle
                    : styles.unCheckedStyle,

                  {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    ":hover": {
                      background:
                        toggleValue === "relevance" ? Colors.primary : "#fff",
                      opacity: 0.85,
                    },
                  },
                ]}
                value={"relevance"}
              >
                {/* Relevance */}
                Document Count
              </ToggleButton>
              <ToggleButton
                value="alphabetical"
                sx={[
                  toggleValue === "alphabetical"
                    ? styles.checkedStyle
                    : styles.unCheckedStyle,
                  {
                    ":hover": {
                      background:
                        toggleValue === "alphabetical"
                          ? Colors.primary
                          : "#fff",
                      opacity: 0.85,
                    },
                  },
                ]}
              >
                Alphabetical
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>
          {Array.isArray(facetData) && facetData.length > 10 && (
            <Stack
              sx={{
                display: {
                  xs: "none",
                  sm: "contents",
                  md: "contents",
                  lg: "contents",
                  xl: "contents",
                },
              }}
            >
              <Button onClick={clearAll}>
                Clear All <CloseIcon fontSize="small" />
              </Button>
            </Stack>
          )}
          {Array.isArray(facetData) && facetData.length > 10 && (
            <IconButton
              sx={{
                display: {
                  xs: "initial",
                  sm: "none",
                  md: "none",
                  lg: "none",
                  xl: "none",
                },
                // mr: "10px",
              }}
              onClick={clearAll}
              size="large"
              color="primary"
            >
              <ClearIcon />
            </IconButton>
          )}
        </Stack>
        <Stack
          direction={"row"}
          alignItems={"center"}
          sx={{ gap: { xs: 1, sm: 2 }, overflowY: "auto" }}
          flexWrap="wrap"
          maxHeight={{ xs: "none", sm: "60vh" }}
        >
          {Array.isArray(facetData) &&
            facetData?.map((data: any) => (
              <Stack
                direction={"row"}
                alignItems="center"
                sx={{ gap: 2 }}
                // width={"400px"}
                width={{ xs: "100%", sm: "400px" }}
              >
                <Stack direction={"row"} alignItems="center">
                  <Checkbox
                    onClick={() => selectedValues(data?.val)}
                    checked={filteredValues?.includes(data?.val)}
                  />
                  <Tooltip title={String(data?.val ?? "")}>
                    <Typography
                      sx={{
                        // width: "250px",
                        width: { xs: "50vw", sm: "250px" },
                        overflow: "hidden",
                        textOverflow: { xs: "none", sm: "ellipsis" },
                        display: "-webkit-box",
                        WebkitLineClamp: { xs: "none", sm: "1" },
                        WebkitBoxOrient: "vertical",
                        textTransform: "capitalize",
                        wordBreak: "break-word",
                        whiteSpace: { xs: "normal", sm: "none" },
                      }}
                    >
                      {/* {data?.val
                        .trim()
                        .replace(/^\,+|\,+$/g, "")
                        .trim()} */}
                      {String(data?.val ?? "")
                        .trim()
                        .replace(/^\,+|\,+$/g, "")
                        .trim()}
                    </Typography>
                  </Tooltip>
                </Stack>
                <Typography>({data?.count})</Typography>
              </Stack>
            ))}
        </Stack>
      </DialogContent>
      <Stack
        direction={"row"}
        alignItems="center"
        sx={{
          gap: 2,
          marginBlock: 2,
          position: "sticky",
          padding: "16px 24px",
        }}
      >
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{ minWidth: 100 }}
        >
          Apply
        </Button>
        <Button onClick={handleCancel} sx={{ minWidth: 150, color: "#111928" }}>
          Cancel
        </Button>
      </Stack>
    </Dialog>
  );
};

export default VTBModal;

const styles = {
  checkedStyle: {
    backgroundColor: Colors.primary,
    color: Colors.white,
    minWidth: "100px",
    borderRadopis: "6px",
  },
  unCheckedStyle: {
    minWidth: "100px",
    color: "#7852FB",
    backgroundColor: "#FFFFFF",
    borderRadopis: "6px",
  },
};
